"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllCustomLessons = exports.deleteCustomLesson = exports.fetchLinkedCourses = exports.validateBeforeDeleteCustomLesson = void 0;
var defaultResponse = {
    id: 12,
    error: '',
    message: 'Operation successfully completed',
    validationErrors: [{ errorKey: '', inputField: '' }],
    success: true,
};
var validateBeforeDeleteCustomLesson = function () { return defaultResponse; };
exports.validateBeforeDeleteCustomLesson = validateBeforeDeleteCustomLesson;
/* eslint-disable import/no-cycle, camelcase, import/prefer-default-export */
var fetchLinkedCourses = function () { return ({
    status: 'ok',
    courses: ['Course Name 1', 'Course Name 2', 'Course Name 3', 'Course Name 4'],
}); };
exports.fetchLinkedCourses = fetchLinkedCourses;
var deleteCustomLesson = function () { return ({
    lessonDeleted: true,
}); };
exports.deleteCustomLesson = deleteCustomLesson;
var getAllCustomLessons = function () {
    var customLessons = __spreadArray([], Array(50), true).map(function (_, i) { return ({
        id: i,
        uuid: 'test3',
        name: 'My custom lesson',
        description: 'My custom lesson description',
        trackCompletion: true,
        includePoints: false,
        lessonDuration: 5,
        createdBy: 'cb@test.com',
        numOfLinkedCourses: 1,
        status: 'linkedToPublished',
    }); });
    return { data: customLessons };
};
exports.getAllCustomLessons = getAllCustomLessons;
